export const REPORTS_TAB_VALUE_BY_KEY = {
  // OLD TAB VALUES (kept as aliases so existing layouts still work)
  // analyticsOverview: 0,
  // reports: 1,
  // tripReplays: 2,
  // dataManagement: 3,
  overview: 0,
  analyticsOverview: 0,
  speedAnalytics: 1,
  tripAnalytics: 2,
  routeAnalytics: 3,
  vehicleAnalytics: 4,
  driverBehavior: 5,
  exportReports: 6,
  reports: 6,
  tripReplays: 7,
  dataManagement: 8,
};

export const REPORTS_TAB_FEATURE_BY_KEY = {
  overview: "/api/managedata/analytics",
  analyticsOverview: "/api/managedata/analytics",
  speedAnalytics: "/api/managedata/analytics",
  tripAnalytics: "/api/managedata/analytics",
  routeAnalytics: "/api/managedata/analytics",
  vehicleAnalytics: "/api/managedata/analytics",
  driverBehavior: "/api/managedata/analytics",
  exportReports: "/api/managedata/reports",
  reports: "/api/managedata/reports",
  tripReplays: "/api/managedata/replays",
  dataManagement: "/api/managedata/datamanagement",
};

export const REPORTS_ANALYTICS_TAB_INDEX_BY_KEY = {
  overview: 0,
  analyticsOverview: 0,
  speedAnalytics: 1,
  tripAnalytics: 2,
  routeAnalytics: 3,
  vehicleAnalytics: 4,
  driverBehavior: 5,
};

export const ANALYTICS_MAIN_TAB_KEYS = [
  "overview",
  "analyticsOverview",
  "speedAnalytics",
  "tripAnalytics",
  "routeAnalytics",
  "vehicleAnalytics",
  "driverBehavior",
];

export const EXPORT_REPORTS_TAB_KEYS = ["exportReports", "reports"];

export const OVERVIEW_TAB_KEYS = ["overview", "analyticsOverview"];

// OLD REPORTS TABS
// const LEGACY_REPORTS_TABS = [
//   {
//     tabKey: "analyticsOverview",
//     labelKey: "Analytics Overview",
//     value: 0,
//     permission: { apiPath: "/api/managedata/analytics", action: "GET" },
//   },
//   {
//     tabKey: "reports",
//     labelKey: "Reports",
//     value: 1,
//     permission: { apiPath: "/api/managedata/reports", action: "GET" },
//   },
//   {
//     tabKey: "tripReplays",
//     labelKey: "Trip Replays",
//     value: 2,
//     permission: { apiPath: "/api/managedata/replays", action: "GET" },
//   },
//   {
//     tabKey: "dataManagement",
//     labelKey: "Data Management",
//     value: 3,
//     permission: { apiPath: "/api/managedata/datamanagement", action: "GET" },
//   },
// ];

const LEGACY_REPORTS_TABS = [
  {
    tabKey: "overview",
    labelKey: "Overview",
    value: 0,
    permission: { apiPath: "/api/managedata/analytics", action: "GET" },
  },
  {
    tabKey: "speedAnalytics",
    labelKey: "Speed Analytics",
    value: 1,
    permission: { apiPath: "/api/managedata/analytics", action: "GET" },
  },
  {
    tabKey: "tripAnalytics",
    labelKey: "Trip Analytics",
    value: 2,
    permission: { apiPath: "/api/managedata/analytics", action: "GET" },
  },
  {
    tabKey: "routeAnalytics",
    labelKey: "Route Analytics",
    value: 3,
    permission: { apiPath: "/api/managedata/analytics", action: "GET" },
  },
  {
    tabKey: "vehicleAnalytics",
    labelKey: "Vehicle Analytics",
    value: 4,
    permission: { apiPath: "/api/managedata/analytics", action: "GET" },
  },
  {
    tabKey: "driverBehavior",
    labelKey: "Driver Behavior",
    value: 5,
    permission: { apiPath: "/api/managedata/analytics", action: "GET" },
  },
  {
    tabKey: "exportReports",
    labelKey: "Export Reports",
    value: 6,
    icon: "download",
    permission: { apiPath: "/api/managedata/reports", action: "GET" },
  },
  {
    tabKey: "tripReplays",
    labelKey: "Trip Replays",
    value: 7,
    permission: { apiPath: "/api/managedata/replays", action: "GET" },
  },
  {
    tabKey: "dataManagement",
    labelKey: "Data Management",
    value: 8,
    permission: { apiPath: "/api/managedata/datamanagement", action: "GET" },
  },
];

export function hasReportsTabPermission(permission, features) {
  if (!permission?.apiPath) {
    return true;
  }
  if (!features) {
    return false;
  }
  return features.some((feature) => feature.api_path === permission.apiPath);
}

function resolveTabLabel(tab, t) {
  return t(tab.labelKey);
}

function filterReportsTabs(tabs, { features }) {
  return tabs.filter((tab) => hasReportsTabPermission(tab.permission, features));
}

export function getLegacyReportsTabs({ t, features }) {
  return filterReportsTabs(LEGACY_REPORTS_TABS, { features }).map((tab) => ({
    ...tab,
    feature: REPORTS_TAB_FEATURE_BY_KEY[tab.tabKey],
    label: resolveTabLabel(tab, t),
  }));
}
